<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddWorksFlag" size="50%" :before-close="handleClose">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="分类名称" prop="name">
                <el-input v-model="addFrom.name" placeholder="请输入分类名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="权重" prop="sequence">
                <el-input v-model.number="addFrom.sequence" placeholder="请输入权重" clearable></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {WorksListAPI} from "@/api/Works/WorkscCassify"
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['AddWorksFlag', "editID"],
  components: {},
  data() {
    return {
      title: "新增",
      addFrom: {
        name: "",
        status: 1,
        sequence: "",
        id: "",
      }, rules: {
        name: [
          {required: true, message: '请输入分类名称', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        sequence: [
          {required: true, message: '请输入权重', trigger: 'blur'},
        ],
      },
      nameRole: "优化师"
    };
  },
  created() {

  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.addFrom = {
        name: "",
        status: "",
        sequence: "",
        id: "",
      },
          this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.addFrom.id == "") {
            let api = WorksListAPI()
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          } else {
            let api = WorksListAPI()
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          }

        } else {
          return false;
        }
      });

    }
  },

  mounted() {
    if (this.editID != "") {
      let api = WorksListAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = {
            name: res.data.name,
            status: res.data.status,
            sequence: res.data.sequence,
            id: res.data.id,
          }
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>